// extracted by css-extract-rspack-plugin
export default {"versionButton":"versionButton-UNU94R","open":"open-VHtdMX"};